import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";

class EditProfile extends React.Component {
    //*Inicializo lo que vamos a editar del perfil*
    initialState = {
        persona_id: 0,
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        nombre_departamento: "",
        nombre_municipio:"",
        telefono:"",
        correo: "",
        options:Api.loadCatalogue("locations"),
        departamento_id: "",
        municipio_id: 0,
        procesando: false,

      };
    
    state = this.initialState;
    
    constructor(props){
        super(props);
    
        if (props.auth.user.name === undefined) {
          this.props.history.push("login");
        }
        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleDepartamentos = this.handleDepartamentos.bind(this);
        this.handleMunicipios = this.handleMunicipios.bind(this);
        this.handleCancelar = this.handleCancelar.bind(this);
    }

	componentDidMount() {
        Api.fetch("app/getDataProfile").then((data) => {
            if(data){
                this.setState({
                    persona_id: data.id,
                    nombre: data.name,
                    apellido_paterno: data.apellido_paterno,
                    apellido_materno: data.apellido_materno,
                    nombre_departamento: data.nombre_departamento,
                    nombre_municipio: data.nombre_municipio,
                    telefono: data.telefono,
                    correo: data.correo,
                    departamento_id: data.departamento_id,
                    municipio_id: data.municipio_id
                });
            }
        });
	}

    handleDepartamentos(e) {
        this.setState({ departamento_id: e.target.value });
      }
    handleMunicipios(e) {
        this.setState({ municipio_id: e.target.value }, () => {});
    }
    
    async handleSubmit(event){
        try{
            event.preventDefault();
            this.setState({ procesando: true });
            
            //getting request ready for fetch (without options), must to be a shallow copy.
            let postData={ ...this.state };
            // shallow copy is inherit of the main state
            delete postData.options;
            
            Api.fetch("app/updateProfile", postData, "PUT")
                .then((data) => this.handleRegister(data))
        }catch(error){
            error.json().then((message) => {this.setState({ procesando: false });
                Swal.fire({title: "Error", icon: "error", text: message});
            }); //catching errors to show notification
        }
    }

    handleRegister(e) {
        Swal.fire({
          title: "Editado correctamente",
          icon: "success",
          text: "Sus datos se han actualizado exitosamente!",
        }).then(()=>{
            window.location="/perfil";
        });
        this.setState({ procesando: false });
    }

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
         object.target.value = object.target.value.slice(0, object.target.maxLength)
          }
    }

    handleCancelar(e){
	    window.location = "/perfil";
    }

	render() {
		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item"><Link to="/">Home</Link></li>
					<li className="breadcrumb-item active"><Link to="/perfil">Perfil</Link></li>
                    <li className="breadcrumb-item active">Editar perfil</li>
				</ol>
				<h1 className="page-header">EDITAR PERIL<small></small></h1>

				<div className="row" onSubmit={this.handleSubmit}>
                    <div className="col-md-9" style={{ left: "10%" }}>
                        <Panel>
                        <PanelBody>
                            <form style={{ margin: "2.5%" }}>
                                {/**NOMBRE *******************/}
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3"> Nombres(s): </label>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        name="nombres"
                                        placeholder="Nombres"
                                        value={this.state.nombre}
                                        onChange={(e) =>
                                            this.setState({ nombre: e.target.value.toUpperCase() })
                                        }
                                        className="form-control "
                                        required
                                    />
                                </div>
                            </div>
                                {/**APELLIDOS ****************/}
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3">Apellido Paterno:</label>
                                <div className="col-md-9">
                                <input
                                    type="text"
                                    name="apellido_paterno"
                                    value={this.state.apellido_paterno}
                                    onChange={(e) =>
                                        this.setState({ apellido_paterno: e.target.value.toUpperCase() })
                                    }
                                    className="form-control"
                                    placeholder="Apellido paterno"
                                    required
                                />
                                </div>
                            </div>
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3">Apellido Materno:</label>
                                <div className="col-md-9">
                                <input
                                    type="text"
                                    name="apellido_materno"
                                    placeholder="Apellido materno"
                                    value={this.state.apellido_materno}
                                    onChange={(e) =>
                                        this.setState({ apellido_materno: e.target.value.toUpperCase() })
                                    }
                                    className="form-control "
                                    //required
                                />
                                </div>
                            </div>
                                {/**DEPARTAMENTO *********************************/}
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3"> Departamento: </label>
                                <div className="col-md-9">
                                <select
                                    onChange={this.handleDepartamentos}
                                    name="departamento_id"
                                    className="form-control m-b-5"
                                    value={this.state.departamento_id}
                                >
                                    {this.state.options.departamentos.map((option) => (
                                    <option
                                        className="dropdown-item"
                                        key={option.id}
                                        value={option.id}
                                    >
                                        {option.name}
                                    </option>
                                    ))}
                                </select>
                                </div>
                            </div>
                                {/**MUNICIPIO *********************************/}
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3"> Municipio: </label>
                                <div className="col-md-9">
                                <select
                                    onChange={this.handleMunicipios}
                                    name="municipio_id"
                                    className="form-control m-b-5"
                                    value={this.state.municipio_id}
                                >
                                    {this.state.options.municipios
                                    .filter(
                                        (e) => e.estado_id === this.state.departamento_id
                                    )
                                    .map((option) => (
                                        <option
                                        //selected={option.id === this.state.municipio_id?'selected': ''}
                                        className="dropdown-item"
                                        key={option.id}
                                        value={option.id}
                                        >
                                        {option.name}
                                        </option>
                                    ))}
                                </select>
                                </div>
                            </div>
                                {/**NOMÁS MOSTRAR EL CORREO ELECTRONICO ************/}
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3">
                                Correo electrónico activo: 
                                </label>
                                <label className="col-form-label col-md-9">
                                    {this.state.correo}
                                </label> 
                            </div>
                                {/**Telefono *********************************/}
                            <div className="form-group row col-md-9">
                                <label className="col-form-label col-md-3"> Teléfono: </label>
                                <div className="col-md-9">
                                <input
                                    type="number"
                                    step="1"
                                    min="0"
                                    value={this.state.telefono}
                                    name="telefono"
                                    pattern="[0-9]{4}[0-9]{4}"
                                    maxLength="8"
                                    onInput={(e) => this.maxLengthCheck(e)}
                                    onChange={(e) =>
                                        this.setState({telefono: e.target.value})
                                    }
                                    className="form-control"
                                    id="telefono"
                                    placeholder="Teléfono"
                                    />
                                </div>
                            </div>
                            
                            <hr />

                            <div
                                className={
                                this.state.procesando
                                    ? "progress rounded-corner m-b-15"
                                    : "hide"
                                }
                            >
                                <div
                                className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                                style={{ width: "100%", height: "20px" }}
                                >
                                <h4>Cargando, Espere...</h4>
                                </div>
                            </div>

                            <div
                                className={this.state.procesando ? "hide" : "pull-right"}
                            >
                                <div style={{ marginBottom: "10%" }}>
                                <button className="btn btn-danger m-r-5" onClick={this.handleCancelar}>
                                    Regresar
                                </button>
                                <button type="submit" className="btn btn-primary m-r-5">
                                    Editar
                                </button>
                                </div>
                            </div>
                            </form>
                        </PanelBody>
                        </Panel>
                    </div>
                    </div>
			</div>
		)
	}
}
//export default RegentInscription;

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <EditProfile auth={auth} history={history} {...props} />;
};